import styled from "@emotion/styled";
import ReactSelect from "react-select";
import colors from "../../../styles/colors";
export const ReactSelectStyled = styled(ReactSelect) `
  .react-select__control.react-select__control--is-disabled {
    background: ${colors["color-gray-30"]};
    color: ${colors["color-gray-120"]};
    .react-select__placeholder {
      color: ${colors["color-blue-180"]};
    }
    .react-select__single-value--is-disabled {
      color: ${colors["color-gray-120"]};
    }
    .react-select__indicator {
      display: none;
    }
  }

  .react-select__control {
    border: none;
    box-shadow: none;
    min-height: 0;
    background: ${(props) => handleBackgroundColor(props)};
    .react-select__single-value {
      margin: 0;
      color: ${colors["color-blue-180"]};
      z-index: 1;
      text-align: left;
    }

    .react-select__placeholder {
      font-size: 0.75rem;
      margin: 0;
      color: ${colors["color-gray-110"]};
      z-index: 1;
      text-align: left;
    }
    :hover {
      border: none;
      shadow: none;
      box-shadow: none;
      background: none;
    }
    :focus {
      background: ${(props) => props.showError ? colors["color-red-20"] : colors["color-blue-30"]};
    }
    .react-select__control--is-focused {
      border: none;
      shadow: none;
      box-shadow: none;
      background: ${(props) => props.showError ? colors["color-red-20"] : colors["color-blue-30"]};
    }
    .react-select__value-container {
      padding: 0;
      margin: 0;
      font-size: 0.75rem;
      :focus-within {
        background: ${(props) => props.showError ? colors["color-red-20"] : colors["color-blue-30"]};
      }
      :hover {
        border: none;
        shadow: none;
        box-shadow: none;
        background: none;
      }
    }
    .react-select__input-container {
      padding: 0;
      margin: 0;
      font-size: 0.75rem;
      input {
        padding: 0;
        margin: 0;
        text-align: left;
      }
      :focus-within {
        background: ${(props) => props.showError ? colors["color-red-20"] : colors["color-blue-30"]};
      }
    }
    .react-select__indicator {
      padding: 0;
      margin: 0;
      position: absolute;
      bottom: 0.5rem;
      right: -0.15rem;
      svg {
        width: 0.75rem;
        height: 0.75rem;
        fill: ${colors["color-blue-120"]};
      }
    }
  }
  .react-select__menu {
    width: calc(100% + 1rem);
    right: 0.5rem;
    left: -0.75rem;
    border-radius: 0rem 0rem 0.375rem 0.375rem;
    text-align: left;
    z-index: 1001;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
    .react-select__option--is-selected {
      background: ${colors["color-blue-30"]};
      color: ${colors["color-black-100"]};
    }
    .react-select__option {
      font-size: 0.75rem;
      padding: 0.5rem 0.75rem 0.25rem 0.75rem;
    }
    .react-select__menu-list {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
`;
export const ReactSelectContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0.188rem;
  box-shadow: none;
  width:100%;
  padding: 0.25rem 0.5rem 0.25rem 0.75rem;
  border-radius: 0.375rem;
  border: 0.063rem solid ${(props) => handleBorderColor(props)};
  ${(props) => props.showHoverShadow
    ? `&:hover {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1),
      0px 0px 1px 0px rgba(0, 0, 0, 0.28);
  }`
    : ``}
 :focus-within {
      background-color: ${(props) => props.showError ? colors["color-red-20"] : colors["color-blue-30"]};
      border: 0.063rem solid ${(props) => props.showError ? colors["color-red-60"] : colors["color-blue-100"]}
    }
    background: ${(props) => handleBackgroundColor(props)};
}`;
const handleBorderColor = (props) => {
    if (props.showError) {
        return colors["color-red-60"];
    }
    return colors["color-gray-80"];
};
const handleBackgroundColor = (props) => {
    if (props.showError) {
        return colors["color-red-20"];
    }
    if (props.disabled) {
        return colors["color-gray-30"];
    }
    return colors["color-white-100"];
};
//# sourceMappingURL=Dropdown.styled.js.map